export default "__VITE_ASSET__hRrVypV1__"